import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'company',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'company',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'company',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'company',
  action: ActionType.DELETE,
};

export const HoldingCompany = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
